import { useEffect, useState, } from "react";

// import { useTranslation } from "react-i18next"

const TYPING_SPEED = 120;
const DELETING_SPEED = 60;
const PAUSE_AFTER_TYPING = 1800;
const PAUSE_BEFORE_NEXT = 700;

export default function TypingEffect({texts, className=""}) {

    // const { t } = useTranslation();

    

    const [textIndex, setTextIndex] = useState(0);
    const [displayText, setDisplayText] = useState("");
    const [phase, setPhase] = useState("typing");

    useEffect(() => {
        const currentText = texts[textIndex];
        let timer;

        switch (phase) {
            case "typing":
                if (displayText.length < currentText.length) {
                    timer = setTimeout(() => {
                        setDisplayText(
                            currentText.slice(0, displayText.length + 1)
                        );
                    }, TYPING_SPEED + Math.random() * 40);
                } else {
                    timer = setTimeout(() => {
                        setPhase("pause");
                    }, PAUSE_AFTER_TYPING);
                }
                break;

            case "pause":
                timer = setTimeout(() => {
                    setPhase("deleting");
                }, 500);
                break;

            case "deleting":
                if (displayText.length > 0) {
                    timer = setTimeout(() => {
                        setDisplayText(
                            currentText.slice(0, displayText.length - 1)
                        );
                    }, DELETING_SPEED);
                } else {
                    timer = setTimeout(() => {
                        setPhase("waiting");
                    }, PAUSE_BEFORE_NEXT);
                }
                break;

            case "waiting":
                setTextIndex((prev) => (prev + 1) % texts.length);
                setPhase("typing");
                break;

            default:
                break;
        }

        return () => clearTimeout(timer);
    }, [displayText, phase, textIndex, texts]);

    return (
        <div className={`typing-div ${className}`}>
            <p className="typing">{displayText}</p>
        </div>
    );
}